module.exports = new __parcel__URL__("gif1.3f047513.webm").toString();